import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card } from './ui/card';
import { toast } from 'sonner';
import { CheckCircle, XCircle } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MyAttendancePage({ token }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/attendance/my`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => setRecords(res.data))
      .catch(() => toast.error('Грешка при зареждане на присъствията'))
      .finally(() => setLoading(false));
  }, [token]);

  const totalPresent = records.filter(r => r.status === 'present').length;
  const totalAbsent = records.filter(r => r.status === 'absent').length;

  if (loading) return <p className="text-slate-500 text-sm">Зареждане...</p>;

  return (
    <div className="space-y-4" data-testid="my-attendance-section">
      <h2 className="text-xl font-semibold text-slate-900">Моите присъствия</h2>

      <div className="grid grid-cols-2 gap-4">
        <Card className="p-4 text-center">
          <div className="text-3xl font-bold text-green-600" data-testid="total-present">{totalPresent}</div>
          <div className="text-sm text-slate-500 mt-1">Присъствия</div>
        </Card>
        <Card className="p-4 text-center">
          <div className="text-3xl font-bold text-red-600" data-testid="total-absent">{totalAbsent}</div>
          <div className="text-sm text-slate-500 mt-1">Отсъствия</div>
        </Card>
      </div>

      {records.length === 0 ? (
        <p className="text-slate-400 text-sm text-center py-10">Няма записани присъствия все още.</p>
      ) : (
        <div className="space-y-2">
          {records.map(r => (
            <div
              key={r.attendance_id}
              data-testid={`attendance-record-${r.attendance_id}`}
              className={`flex items-center justify-between p-3 rounded-lg border ${
                r.status === 'present'
                  ? 'bg-green-50 border-green-200'
                  : 'bg-red-50 border-red-200'
              }`}
            >
              <div>
                <div className="font-medium text-slate-800">{r.date}</div>
                <div className="text-xs text-slate-500 mt-0.5">Отбелязано от: {r.marked_by_name}</div>
              </div>
              <div className={`flex items-center gap-1.5 text-sm font-semibold ${
                r.status === 'present' ? 'text-green-700' : 'text-red-700'
              }`}>
                {r.status === 'present'
                  ? <CheckCircle className="h-4 w-4" />
                  : <XCircle className="h-4 w-4" />}
                {r.status === 'present' ? 'Присъства' : 'Отсъства'}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
